export const environment = {
  production: true,
  apiUrl: "https://developement.topassetgroup.itkaufmann.cloud/api",
  apiFileUrl: "https://developement.topassetgroup.itkaufmann.cloud/",
  passwordMinLength: 8,
  displayDateFormat: "dd.MM.yyyy",
  serverDateFormat: "yyyy-MM-dd",
  planning: {
    colors: {
      singleAssignment: "#2C3E50",
      cycleAssignment: "#2ECC71",
      onCallAssignment: "#6A00FF",
      userTraining: "#F472D0",
      deviceAllocation: "#A0522D",
      maintenance: "#A4C400",
      review: "#FFE4E1",
      sickLeave: "#0050EF",
      holiday: "#800000",
    }
  }
};
